export const initialPolicyDocumentsState = {
    documentsByPolicyId: {},
    sendDocuments: {},
};
export const PolicyDocumentsActionTypes = {
    DOCUMENTS_BY_POLICY_ID: '@@platform/policydocuments/DOCUMENTS_BY_POLICY_ID',
    SEND_DOCUMENTS: '@@platform/policydocuments/SEND_DOCUMENTS',
};
